// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_lw-0";
export var discountCodeInput = "_lw-1";